export default function () {
  return {
    client: null,
    clients: [],
    clientsLoading: false
  }
}
